import React from "react";
import Style from "./ComingSoon.module.css";
import { useHistory } from "react-router-dom";

const ComingSoon = () => {
  const history = useHistory();

  return (
    <div className={Style.pageWrapper}>
      <div className={Style.card}>
        <h1 className={Style.title}>به زودی!</h1>
        <p className={Style.description}>
          ما در حال آماده‌سازی یک تجربه خوب و شگفت‌انگیز برای شما هستیم. 
        </p>
        <button className={Style.button} onClick={()=>history.goBack()}>بازگشت</button>
      </div>
    </div>
  );
};

export default ComingSoon;
